export default __webpack_public_path__ + "static/media/header_logo.0e368e09.png";